import React, { useEffect, useRef, useState } from 'react';
import { Input, Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import { Previous, Next } from '../../../../Constant';
import { handleWheel } from 'Utils/handleWheel';

const PaginationComponent = ({ pagination, handleBackPagination, handleClickPagination, handleNextPagination, maxPagesToShow = 5 }) => {
    const startPage = Math.max(pagination.current_page - Math.floor(maxPagesToShow / 2), 1);
    const endPage = Math.min(startPage + maxPagesToShow - 1, pagination.last_page);

    const [inputValue, setInputValue] = useState(1);
    const timerRef = useRef(null);

    // Membersihkan timer saat unmount
    useEffect(() => {
        setInputValue(pagination.current_page);
        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, []);

    const handleChange = (e) => {
        setInputValue(e.target.value);

        // Clear previous timer
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }

        // Set new timer
        timerRef.current = setTimeout(() => {
            handleClickPagination(e.target.value);
        }, 800);
    };

    return (
        <div className="d-flex justify-content-center align-items-center gap-2">
            <Pagination className="pagination justify-content-center pagination-primary" aria-label="Page navigation example">
                <PaginationItem disabled={pagination.current_page === 1}>
                    <PaginationLink onClick={() => handleBackPagination()}>{Previous}</PaginationLink>
                </PaginationItem>
                {startPage > 1 && (
                    <PaginationItem>
                        <PaginationLink onClick={() => handleClickPagination(1)}>1</PaginationLink>
                    </PaginationItem>
                )}
                {startPage > 2 && (
                    <PaginationItem>
                        <PaginationLink disabled>...</PaginationLink>
                    </PaginationItem>
                )}
                {Array.from({ length: endPage - startPage + 1 }, (_, i) => (
                    <PaginationItem key={startPage + i} active={pagination.current_page === startPage + i}>
                        <PaginationLink onClick={() => handleClickPagination(startPage + i)}>{startPage + i}</PaginationLink>
                    </PaginationItem>
                ))}
                {endPage < pagination.last_page && (
                    <PaginationItem>
                        <PaginationLink disabled>...</PaginationLink>
                    </PaginationItem>
                )}
                {endPage < pagination.last_page && (
                    <PaginationItem>
                        <PaginationLink onClick={() => handleClickPagination(pagination.last_page)}>{pagination.last_page}</PaginationLink>
                    </PaginationItem>
                )}
                <PaginationItem disabled={pagination.current_page === pagination.last_page}>
                    <PaginationLink onClick={handleNextPagination}>{Next}</PaginationLink>
                </PaginationItem>
            </Pagination>
            <Input type="number" onChange={handleChange} value={inputValue} onWheel={handleWheel} style={{ width: '80px', textAlign: 'center' }} />
        </div>
    );
};

export default PaginationComponent;